import axios from "axios"
import store from "@/store"
import ESPHttpService from "./esp-http.service"
// Vue 3: Default export removed - import unused, removing

const ATTEST_URL = import.meta.env.VITE_ATTEST_URL

const ATTEST_TTL = 50 * 1000

let attestation = null
let attestationAt = 0

function attestEnabled() {
  return !!ATTEST_URL && localStorage.getItem("attest_required") !== "0"
}

function fetchAttestation(refresh = false) {
  if (refresh || Date.now() - attestationAt > ATTEST_TTL)
    attestation = null
  if (!attestation) {
    attestationAt = Date.now()
    attestation = axios
      .get(ATTEST_URL, {
        baseURL: "",
        timeout: 3000,
        headers: {},
        transformRequest: [
          (body, headers) => {
            delete headers.common
            delete headers.Authorization
            return body
          },
        ],
      })
      .then(res => res.data)
      .catch(() => {
        attestation = null
        return null
      })
  }
  return attestation
}

const ApiService = {
  init(baseURL) {
    axios.defaults.baseURL = baseURL
  },
  getAttestation(refresh = false) {
    if (!ATTEST_URL)
      return Promise.resolve(null)
    return fetchAttestation(refresh)
  },
  setAttestationRequired(required) {
    localStorage.setItem("attest_required", required ? "1" : "0")
  },
  async refreshToken() {
    try {
      const refreshToken = localStorage.getItem("refresh_token")
      const response = await axios.post("/Account/RefreshToken", {
        userId: JSON.parse(localStorage.getItem("user_info")).id,
        refreshToken,
      })
      localStorage.setItem("refresh_token", response.data.refreshToken)
      localStorage.setItem("access_token", response.data.accessToken)
      this.setHeader()
      return response.data.accessToken
    } catch (error) {
      localStorage.clear()
      this.removeHeader()
      window.location.href = "/login"
      return false
    }
  },
  removeHeader() {
    axios.defaults.headers.common = {}
  },
  setHeader() {
    axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem("auth_token")}`
  },
  get(resource, config = {}) {
    return axios.get(encodeURI(resource), config)
  },
  get2(resource, data) {
    return axios.get(encodeURI(resource), { params: data })
  },
  post(resource, data) {
    return axios.post(resource, data)
  },
  post2(resource, data) {
    return axios.post(resource, null, { params: data })
  },
  formData(resource, data) {
    return axios.post(resource, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  },
  token(resource, data) {
    return axios.post(resource, data, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
    })
  },

  delete(resource) {
    return axios.delete(resource)
  },
  print(resourse, config = {}) {
    return axios.get(resourse, {
      ...config,
      responseType: "blob",
    })
  },
  printtemp(resourse, data) {
    return axios.post(resourse, data, {
      responseType: "blob",
    })
  },
  customRequest(data) {
    return axios(data)
  },
  signedData(data) {
    return ESPHttpService.signedData(data)
  },
  async getSignedData(Service, data) {
    const signDataResponse = await Service.GetSignData(data.id)
    const signedDataResponse = await ESPHttpService.signedData(
      signDataResponse.data.signData,
    )
    data.signedData = signedDataResponse.data.signedMsg
    return data
  },

  async getSignedDataMultiple(Service, data) {
    const signDatas = await Promise.all(
      data.map(async (item) => {
        const signDataResponse = await Service.GetSignData(item.id)
        return signDataResponse.data.signData
      }),
    )

    const signedDataResponse = await ESPHttpService.signedDataMultiple(signDatas)

    data.forEach((e, i) => {
      e.signedData = signedDataResponse.data[i]
    })

    return data
  },
  async isRequireEsp() {
    const q = await this.post(`/account/IsRequireEsp`, {
      userName: JSON.parse(localStorage.getItem("user_info"))?.userName || "",
    }).then((res) => {
      return res.data.isRequireEsp
    })
    return q
  },
  async setSignData(Service, data) {
    const isRequireEsp = await ApiService.isRequireEsp()
    if (isRequireEsp) {
      if (Array.isArray(data)) {
        data = await ApiService.getSignedDataMultiple(Service, data)
      } else {
        data = await ApiService.getSignedData(Service, data)
      }
    }
    return data
  },
  // Create-and-send so'rovlari uchun: data = { data: <hujjat>, signedData }
  async setCreateSignData(Service, data) {
    data.signedData = ""
    const isRequireEsp = await ApiService.isRequireEsp()
    if (isRequireEsp) {
      const signDataResponse = await Service.GetCreateAndHeldSignData(data.data)
      const signedDataResponse = await ESPHttpService.signedData(
        signDataResponse.data.signData,
      )
      data.signedData = signedDataResponse.data.signedMsg
    }
    return data
  },

  mount401Interceptor() {
    const apies = [
      "/cashboxcurrentcondition/GetVirtualConditionByCurrency",
      "/cashboxcurrentcondition/GetConditionByCurrency",
      "/Announcement/GetNew",
    ]
    axios.interceptors.request.use(
      async (config) => {
        if (ATTEST_URL && config.url === ATTEST_URL)
          return config

        const accessToken = localStorage.getItem("access_token")
        if (accessToken) {
          config.headers.Authorization = `Bearer ${accessToken}`
        }
        if (attestEnabled()) {
          const attest = await fetchAttestation()
          if (attest?.data) {
            config.headers["X-Attestation"] = attest.data
          }
        }
        const resUrl = config.url.split("?")[0]
        if (!apies.includes(resUrl)) {
          store.commit("SET_LAST_REQUEST_TIME", Date.now())
        }
        return config
      },
      (error) => {
        return Promise.reject(error)
      },
    )
    this._401interceptor = axios.interceptors.response.use(
      (response) => {
        const resUrl = response.config.url.split("?")[0]
        if (!apies.includes(resUrl)) {
          store.commit("SET_LAST_REQUEST_TIME", Date.now())
        }
        return response
      },
      async (error) => {
        const isRedirectLogin
          = (Date.now() - store.state.lastRequestTime) / (1000 * 60) > 15
        if (error.response) {
          const url = error.response.config.url.split("?")[0]
          if (
            error.response.data?.error === "attestation_invalid"
            && !error.config.attestationRetried
          ) {
            const attest = await fetchAttestation(true)
            if (attest?.data) {
              error.config.attestationRetried = true
              error.config.headers["X-Attestation"] = attest.data
              return axios.request(error.config)
            }
          }
          if (url == "/Account/RefreshToken") {
            localStorage.clear()
            this.removeHeader()
            window.location.href = "/login"
            throw error
          }
          if (error.response.status == 401) {
            if (isRedirectLogin && apies.includes(url)) {
              localStorage.clear()
              this.removeHeader()
              window.location.href = "/login"
            } else {
              const newAccessToken = await this.refreshToken()
              error.config.headers.Authorization = `Bearer ${newAccessToken}`
              return axios.request(error.config)
            }
          }
        }
        if (error.request.status == 403) {
          store.commit("SET_403_ERROR", true)
        }
        throw error
      },
    )
  },

  unmount401Interceptor() {
    axios.interceptors.response.eject(this._401interceptor)
  },
}

export default ApiService
